export default __webpack_public_path__ + "static/media/img-5.c866e637.png";